import type { SiteLogApiResponse, SiteLogQuery } from '@/types/site';
import { XHRAuthorizedClient } from '../client';

export const fetchSiteLogs = async (
  siteId: string,
  query: SiteLogQuery = {}
): Promise<SiteLogApiResponse> => {
  const params = new URLSearchParams();

  if (query.page) params.append('page', query.page.toString());
  if (query.limit) params.append('limit', query.limit.toString());
  if (query.startDate) params.append('startDate', query.startDate);
  if (query.endDate) params.append('endDate', query.endDate);

  const queryString = params.toString();
  const baseUrl = `/sites/${siteId}/logs`;
  const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;

  const response = await XHRAuthorizedClient.get<SiteLogApiResponse>(url);
  return response.data;
};
